var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"id":_vm.id,"options":_vm.outlets,"placeholder":"Select Outlet","custom-label":_vm.nameWithCode,"label":"name","track-by":"name"},model:{value:(_vm.outlet),callback:function ($$v) {_vm.outlet=$$v},expression:"outlet"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }